import update from 'immutability-helper';

export const calculator = (state = {
    investment: 3000,
    percent: false,
    earnings: false,
    discounts: false
}, action) => {
    switch (action.type) {
		case 'MERGE-CALCULATOR-STATES':
			state = update(state, {$merge: action.payload});
		break;

        default:
            return state;
    }

    return state;
};
